import React from 'react'
import {connect} from 'react-redux'
import {MetalColor, Finish, Gemstones, NextSteps, RingFaceShape, RaisedOrRecessed, RingFaceSize, ShoulderDesigns} from './shared'


const METAL_COLOR_CARDS = [
  {
    name: "silver_color",
    img: "//images.custommade.com/44DaTuAfQ-GmVkLi_TuYcCurfAQ=/custommade-attachments/1e44395863331ab_2_metal_color_2_1.jpg",
    label: "White Gold, Silver, Platinum"
  },
  {
    name: "yellow",
    img: "//images.custommade.com/Crertd7jkWEAAb1MsnF4m58F4Zg=/custommade-attachments/5cfb900a1f12ead_2_metal_color_2_2.jpg",
    label: "Yellow Gold"
  },
  {
    name: "rose",
    img: "//images.custommade.com/rMAcoktJlovKDoeGcDbh5DkTl3c=/custommade-attachments/481661548e623d0_2_metal_color_2_3.jpg",
    label: "Rose Gold"
  },
  {
    name: "mixed_metals",
    img: "//images.custommade.com/O8RwIGzr94S5sZEcvjGZjF5-2yQ=/custommade-attachments/426b9c00133a13b_2_metal_color_2_4.jpg",
    label: "Mixed Metals"
  }
]

export class SignetMetalColor extends React.Component {

  render(){
    return (
      <MetalColor cards={METAL_COLOR_CARDS} {...this.props} />
    )
  }
}

const FINISH_CARDS = [
  {
    name: "polished",
    img: "//images.custommade.com/zyMdKC6X_VyJgKvYb6SMHwu-Eoc=/custommade-attachments/6db5a74f49c6340_signet_polished.jpg",
    label: "Polished"
  },
  {
    name: "brushed",
    img: "//images.custommade.com/GYe14PMNnrY06dja89SLv5l1QDU=/custommade-attachments/25ed0274056e10a_signet_brushed.jpg",
    label: "Brushed"
  },
  {
    name: "oxidized",
    img: "//images.custommade.com/gMU5UsFzS9HWEyj1_5VtTYlYl3E=/custommade-attachments/f38133db26d72e2_signet_oxidized.jpg",
    label: "Oxidized"
  },
  {
    name: "enamel",
    img: "//images.custommade.com/Iwi4LERM52oIPN2s6E90gkyiEWk=/custommade-attachments/2548a025cb4c09d_signet_enamel.jpg",
    label: "Enamel"
  }
]

export class SignetFinish extends React.Component {

  render(){
    return (
      <Finish cards={FINISH_CARDS} {...this.props} />
    )
  }
}


const GEMSTONES_CARDS = [
  {
    name: "no_stone",
    img: "//images.custommade.com/EuM8ebN8YfD9tiQoxjXYgE8Jvfs=/custommade-attachments/76a6f4e45210c1b_4_gemstones_4_1.jpg",
    label: "No Stone"
  },
  {
    name: "center_stone",
    img: "//images.custommade.com/zHJBWffkwWmU6BX-7Uo-Z-6rSjw=/custommade-attachments/4d46588bf1a1fe3_4_gemstones_4_2.jpg",
    label: "Center Stone"
  },
  {
    name: "accent_stones",
    img: "//images.custommade.com/m6c6FRVsCFbajO4A31x3xZXV7_o=/custommade-attachments/3d07c611c1d9113_4_gemstones_4_3.jpg",
    label: "Accent Stones"
  }
]

export class SignetGemstones extends React.Component {

  render(){
    return (
      <Gemstones cards={GEMSTONES_CARDS} {...this.props} />
    )
  }
}

const RING_FACE_SHAPE_CARDS = [
  {
    name: "circle",
    img: "//images.custommade.com/2YSFNcWioyocazl6xNEsC7VuWhc=/custommade-attachments/9f95903a10ba690_5_ring_face_shape_5_1.jpg",
    label: "Circle"
  },
  {
    name: "portrait_oval",
    img: "//images.custommade.com/owZCT_7o8EE3ZrsRyQgj3Zz6aRQ=/custommade-attachments/ba2a626df893948_5_ring_face_shape_5_2.jpg",
    label: "Portrait Oval"
  },
  {
    name: "landscape_oval",
    img: "//images.custommade.com/ku9BrtMBiy3TYUYftBZ5P33TO7k=/custommade-attachments/1da2ab42edb77c9_5_ring_face_shape_5_3.jpg",
    label: "Landscape Oval"
  },
  {
    name: "square",
    img: "//images.custommade.com/RNib4FILQEKjNPMbM3ZUGbIXeIM=/custommade-attachments/93b6fb5a1d9cf95_5_ring_face_shape_5_4.jpg",
    label: "Square"
  },
  {
    name: "portrait_rectangle",
    img: "//images.custommade.com/fec4JolgkLhSKVQDCY9pjSn7hRQ=/custommade-attachments/08d9218929f0b05_5_ring_face_shape_5_5.jpg",
    label: "Portrait Rectangle"
  },
  {
    name: "landscape_rectangle",
    img: "//images.custommade.com/qBEislrAzHZguvXZlRK8-E3n9Rs=/custommade-attachments/8a380f361ee491e_5_ring_face_shape_5_6.jpg",
    label: "Landscape Rectangle",
    smallText: true
  },
  {
    name: "shield",
    img: "//images.custommade.com/NnY3Jm_BgnGVd_G8Yza16BU7os0=/custommade-attachments/9f189c20b5a1b6a_5_ring_face_shape_5_7.jpg",
    label: "Shield"
  },
  {
    name: "custom",
    img: "//images.custommade.com/YWzeUg2LIcXI2TBjGVGazapH0K4=/custommade-attachments/03a5cccbd5fb851_5_ring_face_shape_5_8.jpg",
    label: "Custom"
  },
]

export class SignetFaceShape extends React.Component {

  render(){
    return (
      <RingFaceShape cards={RING_FACE_SHAPE_CARDS} {...this.props} />
    )
  }
}


const RAISED_OR_RECESSED_CARDS = [
  {
    name: "raised",
    imgs: [
      "//images.custommade.com/RoN8i5iUCYz2RZ1NJEMc781pu_w=/custommade-attachments/cab60f6378153af_6_raised_or_recessed_6_1.jpg",
      "//images.custommade.com/1B6JQ_A_m_jR6tXkArxpIfqBhxs=/custommade-attachments/f8e52bf1de6bb42_6_raised_or_recessed_6_2.jpg",
      "//images.custommade.com/3zbnuSNEh4gQH-SWSSHroKme-VA=/custommade-attachments/aa5d5e9747307dd_6_raised_or_recessed_6_3.jpg",
    ],
    label: "Raised"
  },
  {
    name: "recessed",
    imgs: [
      "//images.custommade.com/sNF-pGqlGcW3hzMQhHtXHzIt5bs=/custommade-attachments/f3ebf70a082a3f1_6_raised_or_recessed_6_4.jpg",
      "//images.custommade.com/Sn6dQ0vw5KloIdCQcqCHg6mgp_w=/custommade-attachments/eebc9ccfe48270f_6_raised_or_recessed_6_5.jpg",
      "//images.custommade.com/cVu0Ge0GLGM5WSe8NPItPnBPW24=/custommade-attachments/e25721a9d993247_6_raised_or_recessed_6_6.jpg",
    ],
    label: "Recessed"
  },
  {
    name: "recessed_and_mirrored",
    imgs: [
      "//images.custommade.com/ZzlSxbEh1CKREPsdKdRdjiNPR3E=/custommade-attachments/59ba61d70a87c7c_6_raised_or_recessed_6_7.jpg",
      "//images.custommade.com/mdr687ApJ6KHYJrp3p60AcDv5J0=/custommade-attachments/cf6780731d82ba4_6_raised_or_recessed_6_8.jpg",
      "//images.custommade.com/ZJbyrlsGQswxnu4X8PoDbCegMm0=/custommade-attachments/224bafcedac6ee8_6_raised_or_recessed_6_9.jpg",
    ],
    label: "Recessed and Mirrored"
  }
]

export class SignetRaisedOrRecessed extends React.Component {

  render(){
    return (
      <RaisedOrRecessed cards={RAISED_OR_RECESSED_CARDS} {...this.props} />
    )
  }
}


const RING_FACE_SIZE_IMAGES = {
  "female": "//images.custommade.com/w3fdULNIVkq6BZVzjQgjrfKtuwI=/custommade-attachments/0729cdfc7baffd9_female_hand.jpeg",
  "male": "//images.custommade.com/-kalOTEjwJsbYg0PSP9eTrvpnY0=/custommade-attachments/24599f36dea9cba_male_hand.jpg",
  "face_size": "//images.custommade.com/6OFBczxkQeWLysUYI7FZYOK1x3k=/custommade-attachments/9b15153024f196c_7_ring_face_size_2_screen_7_2_2.png",
}

export class SignetRingFaceSize extends React.Component {

  render(){
    return (
      <RingFaceSize cards={RING_FACE_SIZE_IMAGES} {...this.props} />
    )
  }
}

export const SHOULDER_DESIGNS = [
  {
    name: "same_on_both_sides",
    imgs: [
      "//images.custommade.com/UNcsZqlEahdSqZDb4EmiGOxwnWE=/custommade-attachments/34cb75f3e2e81be_8_shoulder_designs_8_1.jpg",
      "//images.custommade.com/i-9uBINAiZDqMjSs_Q0m7_-Gt-Q=/custommade-attachments/eb513b179a49180_8_shoulder_designs_8_2.jpg",
      "//images.custommade.com/yPx_zIIy_CUnQv5oKWQoay6dgzA=/custommade-attachments/8d770ef816c411d_8_shoulder_designs_8_3.jpg",
    ],
    label: "Same on both sides",
    lead_coefficient: 1.2
  },
  {
    name: "different",
    imgs: [
      "//images.custommade.com/zEf9jv28O95aNHut7Vj4_Pj6d54=/custommade-attachments/a8f94260b7a659c_8d160bb544ccd43_screen_8_4_1.jpg",
      "//images.custommade.com/v3amityK-gCDOGYqFfLdSkGfMNM=/custommade-attachments/71a669ef3c1f254_23b1f3d51fad692_screen_8_5_1.jpg",
      "//images.custommade.com/CpnU4WibxdCjt2P92HcwnK8CQMo=/custommade-attachments/46d2c8f82f0e58f_1499efd1618861a_screen_8_6_1.jpg",
    ],
    label: "Different design on each side",
    lead_coefficient: 1.3
  },
  {
    name: "no_designs",
    imgs: [
      "//images.custommade.com/5QCJty5XdqsSY4jv0JG2JZHEyGs=/custommade-attachments/4480bafca99a991_8_shoulder_designs_8_7.jpg",
      "//images.custommade.com/qM6lLIxjAdko3gw8YnyINIHWlv0=/custommade-attachments/3b2f1c282d6c274_8_shoulder_designs_8_8.jpg",
      "//images.custommade.com/StSW8jFGHu6Ow8XPnstoEKXJlM0=/custommade-attachments/b78e1e661d64d2e_8_shoulder_designs_8_9.jpg",
    ],
    label: "No shoulder design",
    lead_coefficient: 0.8
  }
]
export const SIGNET_SHOULDER_DESIGNS_FALLBACK_LEAD_COEFFICIENT = 1.1

export class SignetShoulderDesigns extends React.Component {

  render(){
    return (
      <ShoulderDesigns cards={SHOULDER_DESIGNS} {...this.props} />
    )
  }
}


const NEXT_STEPS_CARDS = [
  {
    name: "price",
    description: "Our design experts will prepare some initial quotes for you to review as a starting point for your ring.",
    label: "I’d like to discuss price first."
  },
  {
    name: "questions",
    description: "If you have other things you’d like to discuss before our team gets started, let us know - one of our ring consultants will get in touch.",
    label: "I have questions to ask or other details to share first."
  },
  {
    name: "looking_around",
    description: "Just looking around for now? We’ll hold onto your details and you can let us know when you’re ready to get started.",
    label: "I’m not ready for a consultation yet."
  }
]


@connect(state => ({
  nextSteps: state.projectCreationData.nextSteps
}))
export class SignetNextSteps extends React.Component {


  render(){
    return (
      <NextSteps cards={NEXT_STEPS_CARDS} {...this.props} />
    )
  }
}
